/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { ModalMultiSelectField, SelectItem } from '../../../shared/ModalMultiSelectField';
import { useAppDispatch } from '../../../core/store';
import { fetchCities, selectCities, selectIsFetching } from '../store/assessmentReportResultsSlice';
import { AssessmentReportFilters } from '../model/assessmentReportQueryParams';

interface CityMultiSelectFieldProps {
  filters: AssessmentReportFilters;
  defaultValue?: string[];
  editable?: boolean;
  onUpdate?: (brand: string[]) => void;
}

export function CityMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: CityMultiSelectFieldProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editable) {
      dispatch(fetchCities(filters));
    }
  }, [dispatch, editable, filters]);

  const items = useSelector(selectCities);
  const isFetching = useSelector(selectIsFetching);

  const toSelectItem = (item: string): SelectItem => {
    return {
      code: item,
      description: item,
    };
  };

  const toString = (item: SelectItem): string => {
    return item.code;
  };

  return (
    <ModalMultiSelectField
      icon='point'
      defaultValue={defaultValue != null ? defaultValue.map(v => toSelectItem(v)) : []}
      loading={isFetching}
      list={items.map((b): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.report.filters.cities') || ''}
      editable={editable}
      onUpdateValue={(selectedBrand: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedBrand.map(i => toString(i)));
        }
      }}
    />
  );
}
